var map = {
	"./1.jpg": 2598,
	"./10.jpg": 9580,
	"./11.jpg": 4841,
	"./12.jpg": 5246,
	"./13.jpg": 6555,
	"./14.jpg": 4968,
	"./15.jpg": 2581,
	"./16.jpg": 8378,
	"./17.jpg": 5895,
	"./18.jpg": 7684,
	"./19.jpg": 5729,
	"./2.jpg": 2945,
	"./20.jpg": 8269,
	"./21.jpg": 7136,
	"./22.jpg": 751,
	"./23.jpg": 8370,
	"./24.jpg": 3857,
	"./25.jpg": 5812,
	"./26.jpg": 3619,
	"./27.jpg": 3510,
	"./28.jpg": 8997,
	"./29.jpg": 5480,
	"./3.jpg": 4900,
	"./30.jpg": 5670,
	"./31.jpg": 5779,
	"./32.jpg": 6068,
	"./33.jpg": 7873,
	"./34.jpg": 2642,
	"./35.jpg": 4351,
	"./36.jpg": 6976,
	"./37.jpg": 1869,
	"./4.jpg": 9839,
	"./5.jpg": 7458,
	"./6.jpg": 7357,
	"./7.jpg": 6224,
	"./8.jpg": 4571,
	"./9.jpg": 3086,
	"./otherworks-1.jpg": 1769,
	"./otherworks.jpg": 1847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9128;